import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RelatedPartyModalService {
  constructor(private http: HttpClient) {}

  private mergeWriteParams(globalParams: any, filterParams: any): any {
    return {
      ...(globalParams || {}),
      ...(filterParams || {}),
    };
  }

  private toUrlEncoded(params: any): string {
    const urlEncoded = new URLSearchParams();
    Object.keys(params || {}).forEach((key: string) => {
      const value = params[key];
      if (value !== undefined && value !== null) {
        urlEncoded.set(key, value.toString());
      }
    });
    return urlEncoded.toString();
  }

  private postFormUrlEncoded(url: string, params: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });
    return this.http.post<any>(url, this.toUrlEncoded(params), {
      headers,
      withCredentials: true,
    });
  }

  /** Save new explanation (action code: b67t0o). */
  saveNewExplanation(
    baseUrl: string,
    jsonData: any[],
    jsonSettings: any,
    codeDesc: string,
    globalParams: any,
    filterParams: any,
  ): Observable<any> {
    const params = {
      ...this.mergeWriteParams(globalParams, filterParams),
      json_data: JSON.stringify(jsonData),
      json_settings: JSON.stringify(jsonSettings),
      code_desc: codeDesc,
    };
    return this.postFormUrlEncoded(
      `${baseUrl}/saveJsonObject?action_code=b67t0o`,
      params,
    );
  }

  /** Save variance explanation (action code: otidof). */
  saveVarExplanation(
    baseUrl: string,
    jsonData: any[],
    jsonSettings: any,
    explnText: string,
    explnType: string,
    globalParams: any,
    filterParams: any,
  ): Observable<any> {
    const params = {
      ...this.mergeWriteParams(globalParams, filterParams),
      json_data: JSON.stringify(jsonData),
      json_settings: JSON.stringify(jsonSettings),
      expln_text: explnText,
      expln_type: explnType,
    };
    return this.postFormUrlEncoded(
      `${baseUrl}/saveJsonObject?action_code=otidof`,
      params,
    );
  }

  /** Remove variance explanation (action code: wr9xus). */
  removeVarExplanation(
    baseUrl: string,
    jsonData: any[],
    jsonSettings: any,
    globalParams: any,
    filterParams: any,
  ): Observable<any> {
    const params = {
      ...this.mergeWriteParams(globalParams, filterParams),
      json_data: JSON.stringify(jsonData),
      json_settings: JSON.stringify(jsonSettings),
    };
    return this.postFormUrlEncoded(
      `${baseUrl}/saveJsonObject?action_code=wr9xus`,
      params,
    );
  }
}
